module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGMAAABjCAMAAAC45U6nAAAAP1BMVEX///8co3D/h0T3+/n/9O0AmmP/gj0AkVX/eS8co3D/h0T3+/n/9O3///8AmmP/gj0AkVX/eS//9O0co3D/h0R89kXaAAAADXRSTlPx8vLx8fHx8fHl5eTkpPVDJgAAAGNJREFUeF7t2jcVgEAUAMEj54x/rRj4FNfwKGYNjIFNTVg3TCm3eezbsLSG7VdacjvvYwt7M4oq26jLnxgMBoPBYDAYDAaDwWAwGAwGg8FgMBgMBoPBYDAYDAaD8cV/9cVH9gCRQvYq6koVtgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/uis/assets/images/flags/Ireland.png
// module id = 581
// module chunks = 0